// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.submit-button {
    display: inline-block;
    font-weight: 400;
   
    text-align: center;
    vertical-align: middle;
    -webkit-user-select: none;
            user-select: none;
  
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
  
    border: none;
    background-color: #ff6f61;
    color: white;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    outline: none;
    padding: 5px;
    
  }
  
  .submit-button:hover {
    outline: none;
    background-color: #e65c54;
  }


  

  
.btn-success-app {
  display: inline-block;
  font-weight: 400;

  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
          user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0;
  color: #fff;
  background-color: #1ab394;
  border-color: #1ab394;
}

.btn-success-app:hover {
  color: #fff;
  background-color: #159278;
  border-color: #14866f;
}

.btn-success-app:focus,
.btn-success-app.focus {
  box-shadow: 0 0 0 0.2rem rgba(60, 190, 164, 0.5);
}

.btn-success-app.disabled,
.btn-success-app:disabled {
  color: #fff;
  background-color: #1ab394;
  border-color: #1ab394;
}

.btn-success-app:not(:disabled):not(.disabled):active,
.btn-success-app:not(:disabled):not(.disabled).active,
.show > .btn-success-app.dropdown-toggle {
  color: #fff;
  background-color: #14866f;
  border-color: #127b66;
}

.btn-success-app:not(:disabled):not(.disabled):active:focus,
.btn-success-app:not(:disabled):not(.disabled).active:focus,
.show > .btn-success-app.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(60, 190, 164, 0.5);
}

.btn-default-app {
  display: inline-block;
  font-weight: 400;

  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
          user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0;
  color: #f8fbfb;
  background-color: #929090;
  border-color: #c3c0c0;
  
}

.btn-default-app:hover {
  color: #edeff1;
  background-color: #a7a2a2;
  border-color: #dfdfdf;
}

.btn-default-app:focus,
.btn-default-app.focus {
  box-shadow: 0 0 0 0.2rem rgba(216, 216, 217, 0.5);
}

.btn-default-app.disabled,
.btn-default-app:disabled {
  color: #212529;
  background-color: #f8f8f8;
  border-color: #f8f8f8;
}

.btn-default-app:not(:disabled):not(.disabled):active,
.btn-default-app:not(:disabled):not(.disabled).active,
.show > .btn-default-app.dropdown-toggle {
  color: #212529;
  background-color: #dfdfdf;
  border-color: #d8d8d8;
}

.btn-default-app:not(:disabled):not(.disabled):active:focus,
.btn-default-app:not(:disabled):not(.disabled).active:focus,
.show > .btn-default-app.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(216, 216, 217, 0.5);
}


.submit-button-disables {
  border: none;
  background-color: #fff;
  color: #ff6f61;
  border-radius: 5px;
  border: 1px solid #ff6f61;
  cursor: pointer;
  transition: background-color 0.3s ease;
  outline: none;
  height: 30px !important;
  padding: 5px;
}

`, "",{"version":3,"sources":["webpack://./src/pages/certifications/certifications.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,gBAAgB;;IAEhB,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;YACjB,iBAAiB;;IAEzB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;;IAEhB,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;IACtC,aAAa;IACb,YAAY;;EAEd;;EAEA;IACE,aAAa;IACb,yBAAyB;EAC3B;;;;;;AAMF;EACE,qBAAqB;EACrB,gBAAgB;;EAEhB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;UACjB,iBAAiB;EACzB,6BAA6B;EAC7B,6BAA6B;EAC7B,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,gDAAgD;AAClD;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;;EAEhB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;UACjB,iBAAiB;EACzB,6BAA6B;EAC7B,6BAA6B;EAC7B,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;;AAEvB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,iDAAiD;AACnD;;AAEA;;EAEE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,iDAAiD;AACnD;;;AAGA;EACE,YAAY;EACZ,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,sCAAsC;EACtC,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd","sourcesContent":[".submit-button {\r\n    display: inline-block;\r\n    font-weight: 400;\r\n   \r\n    text-align: center;\r\n    vertical-align: middle;\r\n    -webkit-user-select: none;\r\n            user-select: none;\r\n  \r\n    padding: 0.375rem 0.75rem;\r\n    font-size: 1rem;\r\n    line-height: 1.5;\r\n  \r\n    border: none;\r\n    background-color: #ff6f61;\r\n    color: white;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease;\r\n    outline: none;\r\n    padding: 5px;\r\n    \r\n  }\r\n  \r\n  .submit-button:hover {\r\n    outline: none;\r\n    background-color: #e65c54;\r\n  }\r\n\r\n\r\n  \r\n\r\n  \r\n.btn-success-app {\r\n  display: inline-block;\r\n  font-weight: 400;\r\n\r\n  text-align: center;\r\n  vertical-align: middle;\r\n  -webkit-user-select: none;\r\n          user-select: none;\r\n  background-color: transparent;\r\n  border: 1px solid transparent;\r\n  padding: 0.375rem 0.75rem;\r\n  font-size: 1rem;\r\n  line-height: 1.5;\r\n  border-radius: 0;\r\n  color: #fff;\r\n  background-color: #1ab394;\r\n  border-color: #1ab394;\r\n}\r\n\r\n.btn-success-app:hover {\r\n  color: #fff;\r\n  background-color: #159278;\r\n  border-color: #14866f;\r\n}\r\n\r\n.btn-success-app:focus,\r\n.btn-success-app.focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(60, 190, 164, 0.5);\r\n}\r\n\r\n.btn-success-app.disabled,\r\n.btn-success-app:disabled {\r\n  color: #fff;\r\n  background-color: #1ab394;\r\n  border-color: #1ab394;\r\n}\r\n\r\n.btn-success-app:not(:disabled):not(.disabled):active,\r\n.btn-success-app:not(:disabled):not(.disabled).active,\r\n.show > .btn-success-app.dropdown-toggle {\r\n  color: #fff;\r\n  background-color: #14866f;\r\n  border-color: #127b66;\r\n}\r\n\r\n.btn-success-app:not(:disabled):not(.disabled):active:focus,\r\n.btn-success-app:not(:disabled):not(.disabled).active:focus,\r\n.show > .btn-success-app.dropdown-toggle:focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(60, 190, 164, 0.5);\r\n}\r\n\r\n.btn-default-app {\r\n  display: inline-block;\r\n  font-weight: 400;\r\n\r\n  text-align: center;\r\n  vertical-align: middle;\r\n  -webkit-user-select: none;\r\n          user-select: none;\r\n  background-color: transparent;\r\n  border: 1px solid transparent;\r\n  padding: 0.375rem 0.75rem;\r\n  font-size: 1rem;\r\n  line-height: 1.5;\r\n  border-radius: 0;\r\n  color: #f8fbfb;\r\n  background-color: #929090;\r\n  border-color: #c3c0c0;\r\n  \r\n}\r\n\r\n.btn-default-app:hover {\r\n  color: #edeff1;\r\n  background-color: #a7a2a2;\r\n  border-color: #dfdfdf;\r\n}\r\n\r\n.btn-default-app:focus,\r\n.btn-default-app.focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(216, 216, 217, 0.5);\r\n}\r\n\r\n.btn-default-app.disabled,\r\n.btn-default-app:disabled {\r\n  color: #212529;\r\n  background-color: #f8f8f8;\r\n  border-color: #f8f8f8;\r\n}\r\n\r\n.btn-default-app:not(:disabled):not(.disabled):active,\r\n.btn-default-app:not(:disabled):not(.disabled).active,\r\n.show > .btn-default-app.dropdown-toggle {\r\n  color: #212529;\r\n  background-color: #dfdfdf;\r\n  border-color: #d8d8d8;\r\n}\r\n\r\n.btn-default-app:not(:disabled):not(.disabled):active:focus,\r\n.btn-default-app:not(:disabled):not(.disabled).active:focus,\r\n.show > .btn-default-app.dropdown-toggle:focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(216, 216, 217, 0.5);\r\n}\r\n\r\n\r\n.submit-button-disables {\r\n  border: none;\r\n  background-color: #fff;\r\n  color: #ff6f61;\r\n  border-radius: 5px;\r\n  border: 1px solid #ff6f61;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s ease;\r\n  outline: none;\r\n  height: 30px !important;\r\n  padding: 5px;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
